<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>货品申请单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="货品申请编号">
                    <el-input v-model="listQuery.applyCode" placeholder="请输入货品申请编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="申请人姓名">
                    <el-input v-model="listQuery.applierName" placeholder="请输入申请人姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="仓库">
                    <el-select v-model="listQuery.houseId" clearable placeholder="请选择仓库" filterable>
                        <el-option v-for="(item,index) in allHouseList" :key="index" :label="item.houseName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="状态">
                    <el-select v-model="listQuery.status" clearable placeholder="请选择状态">
                        <el-option v-for="(item,index) in statusList" :key="index" :label="item.text" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核人姓名">
                    <el-input v-model="listQuery.auditName" placeholder="请输入审核人姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                    <el-button icon="el-icon-plus" type="primary" v-per="'addApplayOrder'" plan @click="addApply">新增申请单</el-button>
                    <el-button icon="el-icon-plus" type="primary" v-per="'addCaigouOrder'" plan @click="addCaiGou">新增采购单</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" @selection-change="handleSelectionChange" border style="width: 100%" class="table">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>

                <el-table-column prop="applierName" label="申请人" width="120" fixed="left"></el-table-column>
                <el-table-column prop="applyCode" label="货品申请编号" width="300"></el-table-column>
                <el-table-column prop="houseName" label="仓库名称"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">{{scope.row.status | statusFilter}}</template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>

                <el-table-column prop="auditName" label="审核人"></el-table-column>
                <el-table-column prop="auditRemark" label="审核备注"></el-table-column>

                <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>
                <el-table-column prop="auditTime" label="审核时间" :formatter="dateFormatA" width="140px"></el-table-column>

                <el-table-column prop label="操作" fixed="right" width="180px" align="center">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" @click="editApply(scope.row)"  size="mini" icon="el-icon-edit" v-if="scope.row.status==1||scope.row.status==2||scope.row.status==4"  >编辑</el-button> -->
                        <el-button type="text" v-per="'productOrderDel'" @click="deleteApply(scope.row)" class="red" size="mini" icon="el-icon-delete" v-if="scope.row.status==1||scope.row.status==4">删除</el-button>
                        <el-button type="text" v-per="'productOrderReview'" @click="auditApply(scope.row)" size="mini" v-if="scope.row.status==2">审核</el-button>
                        <el-button type="text" v-per="'transferStock'" @click="toTransferStock(scope.row)" size="mini" v-if="scope.row.status==5">转仓申请</el-button>
                        <el-button type="text"  @click="showDetail(scope.row)" size="mini" >详情</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <el-dialog title="货品申请单详情" :visible.sync="isShowDetail" width="800px" :close-on-click-modal="false" center>
            <el-table :data="detailList"  border style="width: 100%" class="table">
               
                <el-table-column prop="skuId" label="商品skuId" ></el-table-column> 
                <el-table-column prop="commodityName" label="商品名" ></el-table-column>
                                          <el-table-column prop="skuSpec" label="规格">
                                
                                <template slot-scope="scope">
                                    <span>{{scope.row.skuSpec[0]}}</span>
                                </template>
                            </el-table-column>
                <el-table-column prop="applyNumber" label="申请数量"  ></el-table-column>
                 <el-table-column prop="createTime" label="申请时间" ></el-table-column>
            </el-table>
             <span slot="footer" class="dialog-footer">
                <el-button @click="isShowDetail= false">关闭</el-button> 
            </span>
        </el-dialog>


        <!-- 审核申请单 -->
        <el-dialog title="审核货品申请单" :visible.sync="applyAuditVisible" width="700px" :close-on-click-modal="false" center>
             <el-table :data="detailList"  border style="width: 100%" class="table">
               
                <el-table-column prop="skuId" label="商品skuId" ></el-table-column> 
                <el-table-column prop="commodityName" label="商品名" ></el-table-column>
                     <el-table-column prop="skuSpec" label="规格">
                                
                                <template slot-scope="scope">
                                    <span>{{scope.row.skuSpec[0]}}</span>
                                </template>
                            </el-table-column>
                <el-table-column prop="applyNumber" label="申请数量"  ></el-table-column>
                 <el-table-column prop="createTime" label="申请时间" ></el-table-column>
            </el-table>
            <el-form ref="applyAuditForm" :rules="applyAuditRules" label-width="100px" :model="applyAuditForm" size="medium"  style="padding: 40px 40px 20px">
                <el-row>
                    <el-form-item label="审核状态" prop="auditStatus">
                        <el-select v-model="applyAuditForm.auditStatus" placeholder="请选择审核状态">
                            <el-option label="审核通过" :value="5"></el-option>
                            <el-option label="审核不通过" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="备注" v-if="applyAuditForm.auditStatus==4" prop="auditRemark">
                        <el-input type="textarea" style="width:400px" :rows="3" placeholder="请输入备注" v-model="applyAuditForm.auditRemark"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" v-else>
                        <el-input type="textarea" style="width:400px" :rows="3" placeholder="请输入内容" v-model="applyAuditForm.auditRemark"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="applyAuditVisible= false">取 消</el-button>
                <el-button type="primary" @click="confApplyAudit('applyAuditForm')">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 新增货品申请单 -->
        <el-dialog title="新增货品申请单" :visible.sync="addApplyVisible" width="1000px" :close-on-click-modal="false" center>
            <div style="min-height:400px;">
                <!-- <el-steps :active="activeStep" finish-status="success" simple style="margin-top: 20px">
                    <el-step title="完善商品信息"></el-step>
                </el-steps> -->

                <!-- 第一步 -->
                <div v-if="activeStep==1">
                    <div style="padding:20px 20px;border:1px solid #ddd;">
                        <!-- 商品搜索条件 -->
                        <el-form :inline="true" class="demo-form-inline">
                            <el-form-item label="商品名称">
                                <el-input v-model="productQuery.commodityName" placeholder="请输入商品名称" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="商品编码">
                                <el-input v-model="productQuery.spuCode" placeholder="请输入商品编码" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="商品类目" v-if="productQuery.type==2">
                                <el-cascader v-model="productQuery.categoryId" :options="categoryList" :props="{ expandTrigger: 'hover',value:'id',label: 'categoryName',
          children: 'childCategorys'}" clearable :show-all-levels="false" size="mini"></el-cascader>
                            </el-form-item>
                            <el-form-item label="商品类型">
                                <el-select v-model="productQuery.type" placeholder="请选择商品类型" clearable>
                                    <el-option label="套餐" :value="1"></el-option>
                                    <el-option label="单品" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-search" @click="productSearch">搜索</el-button>
                            </el-form-item>
                        </el-form>

                        <!-- 商品列表 -->
                        <el-table :data="addProductQueryShow" border class="table" max-height="320" ref="multipleTable">
                            <el-table-column prop="commodityName" label="商品名称" width="100" fixed="left"></el-table-column>
                            <el-table-column prop="spuCode" label="商品编码"></el-table-column>
                            <el-table-column prop="categoryName" label="商品类目"></el-table-column>
                            <el-table-column prop="brandName" label="品牌"></el-table-column>
                            <el-table-column prop="salesType" label="销售类型">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.salesType == 1">租借</span>
                                    <span v-if="scope.row.salesType == 2">售卖</span>
                                    <span v-if="scope.row.salesType == 3">租借和售卖</span>
                                    <span v-if="scope.row.salesType == 4">补贴领用</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="satus" label="商品状态">
                                <template slot-scope="scope">{{scope.row.status | productStatus}}</template>
                            </el-table-column>
                            <el-table-column prop="detail.detailDesc" label="商品详情描述"></el-table-column>

                            <el-table-column prop="name" label="操作" width="55">
                                <template slot-scope="scope">
                                    <el-button @click="addConfirm(scope.row)" type="text" size="small">添加</el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <!-- 已选商品 -->
                        <div style="padding:0 10px 10px;border:1px solid #ddd;margin-top:20px;">
                            <el-form style="margin-top:10px;">
                                <el-form-item label="货品申请仓库">
                                    <el-select v-model="skuSelectForm.houseId" clearable placeholder="选择申请仓库" filterable>
                                        <el-option v-for="(item,index) in allHouseList" :key="index" :label="item.houseName" :value="item.id+''"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <!-- 已选单品 -->
                            <p style="margin:20px 0; border-left:4px solid #409EFF;">已选商品：</p>
                            <el-table :data="skuSelectForm.chooseList" border class="table" max-height="320" ref="multipleTable">
                                <el-table-column prop="package" label="商品类型" width="100" fixed="left">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.package==1" style="color:red;">套餐-{{scope.row.spu.commodityName}}</span>
                                        <span v-if="scope.row.package==2" style="color:blue;">单品</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="commodityName" label="商品名称"></el-table-column>
                                <el-table-column prop="propertyValue" label="规格"></el-table-column>
                                <el-table-column label="数量">
                                    <template slot-scope="scope">
                                        <el-input type="number" v-model="scope.row.applyNumber"> </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="" label="操作">
                                    <template slot-scope="scope">
                                        <el-button @click="delRow(scope.$index)" type="text" size="small">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 已选套餐 -->
                            <!-- <p style="margin:20px 0; border-left:4px solid #409EFF;">已选套餐：</p> -->

                        </div>
                    </div>
                </div>
                <!-- 第二步 -->
                <div v-if="activeStep==2" style="padding:100px 0 0;text-align:center;">

                </div>

            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addApplyVisible=false">取消</el-button>
                <!-- <el-button type="primary" @click="nextStep">下一步1</el-button>
                <el-button v-if="activeStep==2" @click="activeStep=1">上一步2</el-button> -->
                <el-button type="primary" @click="confSubmit">提交</el-button>
            </span>
        </el-dialog>

        <!-- 规格选择 -->
        <el-dialog title="商品规格" :visible.sync="skuSelectVisable" width="600px" :close-on-click-modal="false" center>

            <p style="margin:0 20px 20px;">请选择商品规格</p>
            <el-form ref="skuSelectForm" label-width="140px" :model="skuSelectForm" size="medium" v-for="(spu, index) in skuSelectForm.spuList" :key="index">
                <el-row>
                    <el-col :span="6" :offset="2" style="padding-top:6px;">
                        {{spu.spuInfo.commodityName}}
                        <span v-if="spu.curr.type==1">(数量*{{getBomListNumber(spu.curr.bomList,spu.spuInfo.id)}})</span>
                    </el-col>

                    <!--:rules="{  required: true, message: '规格不能为空', trigger: 'blur'-->
                    <el-form-item :label="'选择商品规格'" :prop="'skuId'">
                        <el-select v-model="spu.skuId" placeholder="请选择规格" clearable size="mini">
                            <el-option v-for="item in ( spu.skuList)" :key="item.id" :label="item.propertyValue" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                </el-row>
            </el-form>

            <el-form>
                <el-col :span="4" :offset="2">
                    &nbsp;
                </el-col>
                <el-form-item :label="'请填写申请份数'">
                    <el-input size="mini" style="width:150px;" type="number" v-model="skuSelectForm.tempNumber" placeholder="填写申请数量" clearable></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="skuSelectVisable=false">取消</el-button>
                <el-button @click="confSku" type="primary">确定</el-button>
            </span>

        </el-dialog>

        <!-- 发起转仓 -->
        <transferStock ref="transferStockRef" />

        <!-- 发起采购单 -->
        <purchaseOrderForm ref="purchaseOrderFormRef" />

    </div>
</template>
<script>
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";
import transferStock from "./components/transferStock.vue";
import purchaseOrderForm from "./components/purchaseOrderForm.vue";

let vm;
export default {
    components: { Pagination, transferStock, purchaseOrderForm },
    filters: {
        statusFilter(value) {
            const rs = vm.statusList.filter((item) => {
                return item.id === value;
            });

            if (rs != null && rs.length > 0) {
                return rs[0].text;
            }
        },
    },
    data() {
        return {
            isShowDetail:false,
            chooseTableList: [],
            listData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                applyCode: "",
                applierName: "",
                houseId: "",
                status: "",
                auditName: "",
            },
            statusList: [
                // {
                // 1 编辑中 2 待审核 3 审核中 4 审核不通过 5 审核通过
                //     id: 1,
                //     text: "编辑中",
                // },
                {
                    id: 1,
                    text: "编辑中",
                },
                {
                    id: 2,
                    text: "待审核",
                },
                {
                    id: 3,
                    text: "审核中",
                },
                {
                    id: 4,
                    text: "审核不通过",
                },
                {
                    id: 5,
                    text: "审核通过",
                },
                {
                    id: 6,
                    text: "已采购",
                },
            ],
            allHouseList: [],
            applyHouseList: [],
            applyAuditVisible: false,
            applyAuditForm: {
                auditStatus: 5,
                auditRemark: "",
            },
            applyAuditRules: {
                auditStatus: [
                    {
                        required: true,
                        message: "请选择审核状态",
                        trigger: "change",
                    },
                ],
                auditRemark: [
                    {
                        required: true,
                        message: "请输入备注",
                        trigger: "change",
                    },
                ],
            },
            addApplyVisible: false,
            activeStep: 1,
            productQuery: {
                commodityName: "",
                spuCode: "",
                categoryId: "",
                type: 2,
            },
            addProductQueryShow: [],
            categoryList: [],
            skuSelectVisable: false,
            skuSelectForm: {
                tempNumber: null,
                houseId: "",
                chooseList: [], //是选择的sku
                spuList: [
                    {
                        skuId: "",
                        spuInfo: {},
                        curr: {},
                        skuList: [],
                    },
                    // {
                    //     spuInfo: {
                    //         commodityName: "",
                    //     },
                    //     skuCode: "",
                    // },
                ],
            },
            spuList: [],
            detailList:[]
        };
    },
    beforeCreate() {
        vm = this;
    },
    created() {
        this.querySearch();
        this.getAllHouseList();
        this.getCurrentLoginUserHouse();
    },
    methods: {
        showDetail(row){
            this.isShowDetail=true;
             wmsApi
                .$axiosWmsPurchaseGoodsApplicationDetailo({goodsApplicationId:row.id})
                .then((res) => {
                    this.detailList = res.data.data; 
                })
                
        },
        addCaiGou() {
            //采购发起
            if (this.chooseTableList.length == 0) {
                this.$message.error("请选择表格货品申请单");
                return;
            }

            this.$refs.purchaseOrderFormRef.addApply(this.chooseTableList);
        },
        handleSelectionChange(val) {
            //表格多选框
            console.log(val);
            this.chooseTableList = val;
        },
        toTransferStock(row) {
            //转仓发起
            // this.$refs.transferStockRef.addApply(row);
            this.$refs.transferStockRef.showDetail(row);
        },
        //查询
        querySearch() {
            let temp = {
                page: this.currentPage,
                size: this.pageSize,
                applyCode: this.listQuery.applyCode,
                applierName: this.listQuery.applierName,
                houseId: this.listQuery.houseId,
                status: this.listQuery.status,
                auditName: this.listQuery.auditName,
            };
            wmsApi
                .$axiosGoodsApplicationList(temp)
                .then((res) => {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteApply(row) {
            this.$confirm("确定删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    wmsApi
                        .$axiosGoodsDeleteGoodsApplication({
                            goodsApplicationId: row.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("删除成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => {});
        },
        auditApply(row) {
            this.applyId = row.id;
            this.applyAuditVisible = true;
            this. applyAuditForm={
                auditStatus: 5,
                auditRemark: "",
            };
              wmsApi
                .$axiosWmsPurchaseGoodsApplicationDetailo({goodsApplicationId:row.id})
                .then((res) => {
                    this.detailList = res.data.data; 
                })

        },
        confApplyAudit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    wmsApi
                        .$axiosGoodsAuditGoodsApplication({
                            goodsApplicationId: this.applyId,
                            auditStatus: this.applyAuditForm.auditStatus,
                            auditRemark: this.applyAuditForm.auditRemark,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("提交成功");
                                this.applyAuditVisible = false;
                                this.querySearch();
                            } else {
                                this.$message.error(res.data.data);
                            }
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        getAllHouseList() {
            wmsApi
                .$axiosGetWmshousePageList({
                    pageNum: 1,
                    pageSize: 1000,
                })
                .then((res) => {
                    this.allHouseList = res.data.data.list;
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        getCurrentLoginUserHouse() {
            wmsApi
                .$axiosGeCurrentLoginUserHouse()
                .then((res) => {
                    this.applyHouseList = res.data.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        addApply() {
            this.addApplyVisible = true;
            this.skuSelectForm.chooseList = [];
            wmsApi
                .$axiosCategoryTree({})
                .then((res) => {
                    this.categoryList = res.data.data;
                })
                .catch((err) => {
                    console.log(err);
                });
            this.productQuery = {
                commodityName: "",
                spuCode: "",
                brandName: "",
                categoryId: "",
                type: 2,
            };
            this.productSearch();
            //   if (this.addProductQueryShow.length == 0) {
            //     this.productSearch();
            //   }
        },
        productSearch() {
            let temp = {
                page: 1,
                size: 1000,
                type: this.productQuery.type,
                status: 4,
                commodityName: this.productQuery.commodityName,
                spuCode: this.productQuery.spuCode,
            };
            if (this.productQuery.type == 2) {
                temp.categoryId =
                    this.productQuery.categoryId.length >= 3
                        ? this.productQuery.categoryId[2]
                        : "";
            }
            wmsApi
                .$axiosCommodityList(temp)
                .then((res) => {
                    this.addProductQueryShow = res.data.data.list;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        addConfirm(row) {
            console.log(row);
            this.skuSelectVisable = true;
            this.skuSelectForm.tempNumber = null;

            if (row.type == 1) {
                //套餐
                this.skuSelectForm.spuList = [];
                row.childCommoditys.childDetail.forEach((e) => {
                    let dataArr = {
                        skuId: "",
                        curr: row,
                        spuInfo: e.spuInfo,
                        skuList: e.childSpuDetail,
                    };
                    this.skuSelectForm.spuList.push(dataArr);
                });
            } else {
                //单品
                this.skuSelectForm.spuList = [];
                let dataArr = {
                    skuId: "",
                    curr: row,
                    spuInfo: row,
                    skuList: row.childCommoditys.childDetail,
                };
                this.skuSelectForm.spuList.push(dataArr);
            }
        },
        confSku() {
            console.log("选择了", this.skuSelectForm);
            // this.tempArrayList
            if (this.isEmptyObjVue(this.skuSelectForm.tempNumber)||this.skuSelectForm.tempNumber==0) {
                this.$message.error("请填写申请数量");
                return;
            }else if(!/^[1-9]\d*$/.test(this.skuSelectForm.tempNumber+'')){
                this.$message.error("申请数量只能为正整数");
                return;
            }

            let temparr = [];

            this.skuSelectForm.spuList.forEach((e) => {
                e.skuList.forEach((tsk) => {
                    var sk = JSON.parse(JSON.stringify(tsk));
                    if (e.skuId == sk.id) {
                        sk.package = e.curr.type; //标识1套餐，2单品
                        sk.spu = e.curr;
                        if (e.curr.type == 2) {
                            sk.applyNumber = this.skuSelectForm.tempNumber; //要提交的
                        } else {
                            let num = this.getBomListNumber(
                                e.curr.bomList,
                                e.spuInfo.id
                            );
                            sk.applyNumber =
                                num * this.skuSelectForm.tempNumber;
                        }

                        sk.skuId = sk.id; //要提交的
                        temparr.push(sk);
                    }
                });
            });

            if (
                temparr.length == 0 ||
                temparr.length != this.skuSelectForm.spuList.length
            ) {
                this.$message.error("请选择商品规格");
                return;
            }
            this.skuSelectForm.chooseList =
                this.skuSelectForm.chooseList.concat(temparr);

            console.log("总共选择了", this.skuSelectForm);

            this.skuSelectVisable = false;
        },
        getBomListNumber(bomList, spuId) {
            if (bomList == null || bomList == undefined) {
                return 0;
            }
            let num = 0;
            bomList.forEach((e) => {
                if ((e.spuId = spuId)) {
                    num = e.num;
                }
            });
            return num;
        },
        delRow(index) {
            this.skuSelectForm.chooseList.splice(index, 1);
        },

        nextStep() {},
        confSubmit() {
            if (this.skuSelectForm.chooseList.length == 0) {
                this.$message.error("请添加商品");
                return;
            }
            for (let i = 0; i < this.skuSelectForm.chooseList.length; i++) {
                if (
                    !this.skuSelectForm.chooseList[i].applyNumber ||
                    this.skuSelectForm.chooseList[i].applyNumber <= 0
                ) {
                    this.$message.error("商品数量不能小于0");
                    return;
                }else if(!/^[1-9]\d*$/.test(this.skuSelectForm.chooseList[i].applyNumber+'')){
                   this.$message.error("商品数量只能为正整数");
                    return;
                }
            }
            if (this.skuSelectForm.houseId == null) {
                this.$message.error("请选择申请仓库");
                return;
            }
            let reqdata = {
                applierName: globalData.userInfo.userName,
                applyId: globalData.userInfo.id,
                goodsItems: [],
                houseId: this.skuSelectForm.houseId,
                // remark: "",
            };
            this.skuSelectForm.chooseList.forEach((e) => {
                reqdata.goodsItems.push({
                    applyNumber: e.applyNumber,
                    skuId: e.skuId,
                });
            });

            wmsApi
                .$axiosCreateNewGoodsApplication(reqdata)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.$message.success("提交成功");
                        this.addApplyVisible = false;
                        this.querySearch();
                    } else {
                        this.$message.error(res.data.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>
